export default "__VITE_ASSET__BdDBW0_R__"